exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.feedItem[data-v-080f3ff2] {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  height: auto !important;\n}\n.cardBg[data-v-080f3ff2] {\n  position: absolute;\n  background-position: center;\n  background-size: cover;\n  right: 0;\n  top: 0;\n  z-index: 0;\n}\n.cardContent[data-v-080f3ff2] {\n  background-color: rgba(34, 44, 60, 0.8);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n.colorInherit[data-v-080f3ff2] {\n  color: inherit;\n}\n.newsRowHolder[data-v-080f3ff2] {\n  height: 100px;\n}\n.newsRowHolder .iamgeHolder[data-v-080f3ff2] {\n    width: 35%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n}\n.newsRowHolder .textHolder[data-v-080f3ff2] {\n    width: 65%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-080f3ff2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardNews.vue
// module id = 2406
// module chunks = 0